export interface SFTPSettings {
  _id: string;
  name: string;
  directory: string;
  created_at: string;
  type: SFTPType;
}

export interface SFTPSettingsDto {
  username: string;
  slug: string;
  type: SFTPType;
  password?: string;
  password_confirm?: string;
  public_key?: string;
  directory: string;
}

export interface SFTPInstructions extends SFTPSettings {
  password: string;
  public_key: string;
  user_id: string;
  audit_logs: AuditLog[];
  connectors?: Connector[];
}

export interface AuditLog {
  id: string;
  type: SFTPType;
  user_id: string;
  email: string;
  created_at: string;
}

export interface Connector {
  _id: string;
  name: string;
  guid: string;
  author_id: string;
}

export enum SFTPType {
  PASSWORD = 'password',
  SSH_RSA = 'ssh/rsa'
}

export enum LogType {
  PasswordRevealed = 'password_revealed',
  InstructionsViewed = 'instructions_viewed',
  InstructionsSent = 'instructions_sent'
}

export const SERVER = 'sftp2.data.451.io';
export const PORT = 22;
